import Vue from 'vue'
import { getInformation } from "@/api/api";
import urlencode from "urlencode";
/**
 * 处理ulr的参数
 */
let query = {}
let reg = /\?.*/g
let location  = window.location.href.match(reg)[0].substring(1)
let index = location.indexOf('#')
if (index > 0) {
    location = location.substring(0, index)
}
location
.replace(/\/|\#/g, '')
.split('&')
.map(item => item.split('='))
.forEach(item => query[item[0]] = item[1])

let data = new Vue({
    data: {
        AccessionNumber: query.AccessionNumber,
        house_id: query.house_id,
        password: query.password,
        key: query.key,
        phone_key: query.phone_key,
        open_id: query.open_id,
        data: {}
    },
    methods: {
        urrl(ipdp, bHistory) {
            let local = false;

            let url = ''
            if (!this.key) {
                url = `https://sys.baijiecloud.com/api/getImg?AccessionNumber=${this.AccessionNumber}&house_id=${this.house_id}&check_phone_key=${this.phone_key}`
            }else{
                url = `https://sys.baijiecloud.com/api/getImg?password=${this.password}&key=${this.key}&house_id=${this.house_id}&check_phone_key=${this.phone_key}`
            }
            let uer = `https://${local?'www.baijiecloud.com':'www.baijiecloud.com'}/dicom_view/Viewer?lng=zh&url=${urlencode(url)}`
            window.location.href = uer;
        },
        urrl_old(ipdp, bHistory) {
            let local = false;
            var uer = `https://${local?'www.baijiecloud.com':'www.baijiecloud.com'}/report.html?house_id=${this.house_id}&`
            if (this.key) {
            uer += `key=${this.key}`
            } else {
                uer += `AccessionNumber=${this.AccessionNumber}`
            }
            if (this.password) {
                uer += `&password=${this.password}`
            }
            if (this.phone_key) {
                uer += `&check_phone_key=${this.phone_key}`
            }
            console.warn('ipdp=',ipdp);
            if(ipdp!==undefined){
                uer += '&is_open_dicom_processing=' + ipdp;
            }
            if (bHistory){
                uer += `&is_history=1`
            }
            uer += '&_v=202103082';
            window.location.href = uer;
        },
        getData(resolve, reject) {
            console.log('getData', this.data)
            if (this.data.hospital_patient_name) {
                resolve && resolve()
                return
            }
            let paramKey = this.key ? 'key' : 'AccessionNumber'
            let password = this.password
            let params = {
                [paramKey]: this[paramKey],
                house_id: this.house_id
            }
            if (password) params.password = password
            if (this.phone_key) params.check_phone_key = this.phone_key

            getInformation(params).then(res => {
                console.warn('res', res)
                if(res.mesaage === '需要验证手机号后四位'){
                    this.data = {
                        needVerifyPhone: true
                    }
                } else if(!!res.data.delete_time){
                    this.data = {
                        delete_time: res.data.delete_time
                    }
                }else{
                    if(res.data){
                        if (res.data.hospital_patient_name) {
                            document.title = document.title + ' ' + res.data.hospital_patient_name
                        }
                        if (res.data.hospital_check_time) {
                            document.title = document.title + ' ' + res.data.hospital_check_time
                        }

                    }
                    this.data = res.data
                }
                resolve && resolve()
            }).catch((err) => {
                reject && reject(err)
            })
        }
    }
})

data._data.urrl = (iodp, bHistory) => data.urrl(iodp, bHistory)
data._data.getData = (cb, err) => data.getData(cb, err)

export default data._data
